export interface RightNavTopicItem {
  name: string;
  link: string;
}

export interface RightNavTopic {
  name: string;
  items: RightNavTopicItem[];
}
